// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_angular_material_fesm2022_icon_mjs-node_modules_angular_material_fesm202-ca6acf":"dd2f24ae79d72954","src_app_contracts-awarded_contracts-awarded_module_ts":"aa43be76c2c91aee","src_app_supplier-payments_supplier-payments_module_ts":"7a2dd7d37894cc5f"}[chunkId] + ".js";
};